import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteAllNotifications } from '../api/notifications.api';

/**
 * Hook for deleting all notifications for the current user.
 * Invalidates notification queries on success.
 */
export const useDeleteAllNotifications = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAllNotifications,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};
